import React from 'react';
import { Card, Statistic, Divider, Row, Col, Empty } from 'antd';

const fmt = (n) =>
  new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  }).format(n || 0);

const BUCKETS = ['0-30', '31-90', '91-180', '180+'];

function PipelineComercialTile({ data, loading }) {
  if (loading) return <Card title="Pipeline comercial" loading />;
  if (!data) {
    return (
      <Card title="Pipeline comercial">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  const agingByBucket = Object.fromEntries(
    (data.aging || []).map((r) => [r.bucket, r])
  );

  return (
    <Card title="Pipeline comercial">
      <Statistic
        title="Esperando aprobar"
        value={fmt(data.esperando_aprobar.monto)}
        suffix={`(${data.esperando_aprobar.count})`}
        valueStyle={{ fontSize: '1.4rem', color: '#faad14' }}
      />
      <Divider style={{ margin: '12px 0' }} />
      <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 8 }}>
        Aging de ODT no asignadas:
      </div>
      <Row gutter={[4, 8]}>
        {BUCKETS.map((b) => {
          const row = agingByBucket[b];
          return (
            <Col span={12} key={b}>
              <div style={{ fontSize: 11, color: '#8c8c8c' }}>{b} días</div>
              <div style={{ fontWeight: 600, fontSize: 13 }}>
                {row ? `${row.count} · ${fmt(row.monto)}` : '0 · $0'}
              </div>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
}

export default PipelineComercialTile;
